<template>
  <validation-observer
    ref="backupScheduleSaveFormRef"
    #default="{invalid}"
  >
    <b-modal
      id="backupScheduleSaveModal"
      body-class="position-static"
      centered
      :title="isCreated ? 'Thêm lịch sao lưu' : 'Cập nhật lịch sao lưu'"
      @show="onShow"
      @hide="onHide"
    >
      <b-form>
        <b-form-group label-for="name">
          <template v-slot:label>
            Tên <span class="text-danger">*</span>
          </template>
          <validation-provider
            #default="{ errors }"
            name="Tên"
            rules="required"
          >
            <b-form-input
              id="name"
              v-model="targetSchedule.name"
              name="name"
              placeholder="Nhập tên"
              :state="getElementState(errors)"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <b-form-group
          v-if="targetSchedule.status === 0"
          label-for="expression"
        >
          <template v-slot:label>
            Biểu thức <span class="text-danger">*</span>
          </template>
          <validation-provider
            #default="{ errors }"
            name="Biểu thức"
            rules="required"
          >
            <b-form-input
              id="code"
              v-model="targetSchedule.expression"
              name="code"
              placeholder="* * * * * ?"
              :state="getElementState(errors)"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-form>
      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button
            v-show="isCreated"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1"
            :disabled="invalid"
            @click="onSave"
          >
            <span class="text-right">
              <feather-icon icon="CheckIcon" /> Lưu và tiếp tục
            </span>
          </b-button>

          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1"
            :disabled="invalid"
            @click="onSave('hide')"
          >
            <span class="text-right">
              <feather-icon icon="CheckIcon" /> Lưu lại
            </span>
          </b-button>

          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-secondary"
            @click="$bvModal.hide('backupScheduleSaveModal')"
          >
            <span class="text-right">
              <feather-icon icon="XIcon" /> Hủy
            </span>
          </b-button>
        </div>
      </template>
      <b-overlay
        no-wrap
        variant="white"
        spinner-variant="primary"
        blur="0"
        opacity=".75"
        rounded="sm"
        :show="isLoading"
      />
    </b-modal>
  </validation-observer>
</template>

<script>
import {
  BForm, BFormGroup, BFormInput, BModal, BOverlay, BButton,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import { mapActions } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import { Flag } from '@/const/flag'

export default {
  name: 'ScheduleSave',
  components: {
    BFormGroup,
    BFormInput,
    BModal,
    BForm,
    BOverlay,
    BButton,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    schedule: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      isLoading: false,
      targetSchedule: {
        name: '',
        expression: '',
        status: Flag.DEACTIVATE,
      },
      required,
    }
  },
  computed: {
    isCreated() {
      return !this.schedule
    },
  },
  methods: {
    ...mapActions({
      createSchedule: 'backupSchedule/createSchedule',
      updateSchedule: 'backupSchedule/updateSchedule',
    }),
    getElementState(errors) {
      return errors.length > 0 ? false : null
    },
    onShow() {
      if (this.schedule) {
        this.targetSchedule = { ...this.schedule }
      }
    },
    onHide() {
      this.$refs
        .backupScheduleSaveFormRef
        .reset()
      this.targetSchedule = {
        name: '',
        expression: '',
        status: Flag.DEACTIVATE,
      }
    },
    async onSave(type = null) {
      const valid = this.$refs
        .backupScheduleSaveFormRef
        .validate()
      if (valid) {
        this.isLoading = true
        try {
          const response = this.isCreated
            ? await this.createSchedule(this.targetSchedule)
            : await this.updateSchedule(this.targetSchedule)
          if (response) {
            const { isSuccessful, message } = response
            if (isSuccessful) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: message,
                  icon: 'CheckIcon',
                  variant: 'success',
                },
              })
              if (type === 'hide') {
                this.$bvModal.hide('backupScheduleSaveModal')
              }
              this.$emit('succeed')
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: message,
                  icon: 'XCircleIcon',
                  variant: 'danger',
                },
              })
            }
          }
        } catch (e) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `[${e.code}] ${e.message}`,
              icon: 'XCircleIcon',
              variant: 'danger',
            },
          })
        } finally {
          this.isLoading = false
        }
      }
    },
  },
}
</script>
